import { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { TranslationsKeys } from '../../../../locales/translations';
import { getHomologationFormData } from '../api';
import { HomologationFormDataResponse } from '../types';

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  HomologationFormDataResponse,
  AxiosResultDefaultError
>();

export function useHomologationFilterLoader() {
  return useFetch();
}

export default function HomologationFilterLoader({
  children,
}: {
  children: ReactElement | ReactElement[];
}) {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION);

  const request = useCallback(async () => {
    return getHomologationFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading insideCard />;
          } else if (error) {
            return (
              <DisplayError
                insideCard
                title={t('error.title')}
                textBody={t('error.body')}
                retryAction={refresh}
              />
            );
          } else if (data) {
            return <>{children}</>;
          }
          return null;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
